<template>
	<v-dialog v-model="dialog" max-width="500">
		<v-card>
			<v-card-title>
				추천 상품 변경
			</v-card-title>
			<v-card-text>
				<v-btn color="white" class="primary--text px-2 ml-1" @click="update(true)">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>추천 상품 등록
                </v-btn>
                <v-btn color="white" class="primary--text px-2 ml-1" @click="update(false)">
                    <v-icon class="mr-2">mdi-microsoft-excel</v-icon>추천 상품 해제
                </v-btn>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data() {
		return {
			dialog: false,
		}
	},
	methods: {
		open() {
			this.dialog = true;
		},
		close() {
			this.dialog = false;
		},
		update(isRecommend) {
			this.$emit("updateRecomendProduct", isRecommend)
			this.close()
		}
	}
}
</script>

<style>

</style>